import MainLayout from '@/components/layouts'
import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import { type MenuItem, MenuItemAdmin } from '@/routes/MenuItem'
import ROUTER from '@/routes/ROUTER'
import { useRouterContext } from '@/shared/context'
import type { TabLogin } from '@/shared/types'
import { storage } from '@/shared/utils/storage'
import { hasPermission } from '@/shared/utils/utils'
import { Result } from 'antd'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom'

export const setShowListMenu = (list: MenuItem[], listTab?: TabLogin[]): MenuItem[] =>
  list
    .filter((x) => hasPermission(x?.tabid, listTab))
    .map((i) => ({
      ...i,
      children: i.children ? setShowListMenu(i.children, listTab) : undefined,
    }))
function AdminRoutes() {
  const { setRouterBefore } = useRouterContext()

  // const { listTab } = useListTab()
  // const { listTabs, userInfo } = useSelector((state: any) => state?.appGlobal)
  const { listTabs } = useSelector((state: any) => state?.appGlobal)
  const [menuAdmin, setMenuAdmin] = useState<MenuItem[]>([])
  const isLogin = storage.getAuthToken()
  const location = useLocation()
  useEffect(() => {
    if (!isLogin) setRouterBefore(`${location.pathname}${location?.search}`)
  }, [isLogin, location, setRouterBefore])

  // Debug
  useEffect(() => {
    if (isLogin) {
      const rootMenu = MenuItemAdmin()
      console.log('1. Danh sách menu gốc:', rootMenu)
      console.log('2. Quyền hiện tại của User (listTab):', listTabs)

      const menu = setShowListMenu(rootMenu, listTabs)
      console.log('3. Menu sau khi lọc:', menu)

      setMenuAdmin(menu)
    }
  }, [isLogin, listTabs])
  return isLogin ? (
    <div style={{ maxWidth: '100%', maxHeight: '100vh', overflowX: 'hidden' }}>
      {menuAdmin?.length > 0 ? (
        <MainLayout type="isAdmin">
          <Outlet />
        </MainLayout>
      ) : (
        <Result
          status="403"
          title="403 Erorr Permission"
          subTitle="Xin lỗi, Bạn không có quyền truy cập trang web."
          extra={
            <NavLink to={ROUTER.DEFAULT}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ButtonCustom className="btn-hover-shadow">Quay lại trang chủ</ButtonCustom>
              </div>
            </NavLink>
          }
        />
      )}
    </div>
  ) : (
    <Navigate to={ROUTER.HOME} />
  )
}

export default AdminRoutes
